import { SetMemberAccessDocument } from "@pathwright/graphql-client/src/generated"

export default SetMemberAccessDocument
